import React from 'react';
import { Text } from '@billda/design-system';
import { PlatformOrganisationDto } from '../../api/platformApi';
import { PlatformOrganisationListItem } from '../molecules/PlatformOrganisationListItem';
import { ListViewShell } from '../../../../shared/components/ui/ListViewShell';

interface PlatformOrganisationsListViewProps {
  organisations: PlatformOrganisationDto[];
  loading: boolean;
}

export const PlatformOrganisationsListView: React.FC<
  PlatformOrganisationsListViewProps
> = ({ organisations, loading }) => {
  return (
    <ListViewShell
      itemCount={organisations.length}
      loading={loading}
      emptyMessage="No organisations found"
      data-testid="platform-organisations-list"
      columnHeaders={
        <>
          <Text variant="caption" color="secondary" className="flex-1">
            Name
          </Text>
          <div className="hidden shrink-0 items-center gap-4 sm:flex">
            <Text variant="caption" color="secondary" className="w-[240px]">
              Owner
            </Text>
            <Text variant="caption" color="secondary" className="w-[100px]">
              Created
            </Text>
          </div>
          <Text
            variant="caption"
            color="secondary"
            className="w-[90px] text-right"
          >
            Status
          </Text>
        </>
      }
    >
      {organisations.map(org => (
        <PlatformOrganisationListItem key={org.id} organisation={org} />
      ))}
    </ListViewShell>
  );
};
